
import axios from 'axios';

export async function refreshToken(host, refreshToken) {
    try {
        const response = await axios.post(`${host}/auth/refresh-token`, {
            refreshToken: refreshToken,
        }, {
            headers: {
                'Content-Type': 'application/json',
                'response-type': 'json',
                'Authorization': `Bearer ${localStorage.getItem('jwt')}`
            },
        })
        const payload = response.data;

        if (payload.success) {
            localStorage.setItem('jwt', payload.data.accessToken);
            localStorage.setItem('id_token', payload.data.idToken);
            localStorage.setItem('expiresAt', new Date().getTime() + (payload.data.expiresIn * 1000));
        } else {
            logout()
        }
    } catch (error) {
        logout()
    }
}

export function logout() {
    localStorage.removeItem('jwt')
    localStorage.removeItem('id_token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('expiresIn')
    localStorage.removeItem('expiresAt')
    localStorage.removeItem('tokenType')
    localStorage.removeItem('auth')
    // Backbone.history.navigate('/login', false);
    window.location.href = '/login'
}

export const requestCheckTokenInterceptor = (host) => async action => {
    const oldRefreshToken = localStorage.getItem('refreshToken');
    const accessToken = localStorage.getItem('jwt');
    const expiresAt = localStorage.getItem('expiresAt');

    if (oldRefreshToken && accessToken) {
        const remainingTime = (expiresAt - Date.now());
        const oneMinuteInMilliseconds = 60000;
        const limit = 10 * oneMinuteInMilliseconds;
        const shouldRefresh = remainingTime < limit;
        if (shouldRefresh) {
            await refreshToken(host, oldRefreshToken)
        }
    }

    return action;
};

